<!-- <a *ngIf="!loggedin" class="w3-bar-single-item login-btn"
onclick="document.getElementById('id01').style.display='block'">Login</a>
<a *ngIf="!loggedin" class="w3-bar-single-item login-btn"
onclick="document.getElementById('id02').style.display='block'">Sign Up</a> -->
<!--Login form-->
<!-- <div id="id01" class="modal">
    <div class="modal-inner">
        <app-login-form></app-login-form>
    </div>
</div> -->
<!--Login form END-->

<!--Register form-->
<!-- <div id="id02" class="modal">
    <div class="modal-inner RegisterForm">
        <app-register-form></app-register-form>
    </div>
</div> -->
<!--register form END-->

<nav class="navbar navbar-light navbar-expand-lg fixed-top bg-white clean-navbar" id="top-nav">
    <div class="container navbar-inner">
        <a class="navbar-brand logo" href="#" style="padding: 0px 0px;">
            <div class="logo-div"><img class="img-fluid" src="assets/img/logos/JijengeeLogo.png" style="width: 200;height: 100;" width="120" height="100" alt="logo">
            </div>
        </a>
        <button data-toggle="collapse" class="navbar-toggler" data-target="#navcol-1">
            <span class="sr-only">Toggle navigation</span><span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navcol-1">
            <ul class="nav navbar-nav mx-auto">
                <li class="nav-item " role="presentation"><a class="nav-link active" routerLink="" href="/">Home</a></li>
                <li class="nav-item" role="presentation"><a class="nav-link" href="#features">Features</a></li>
                <!-- <li class="nav-item" role="presentation"><a class="nav-link" href="pricing.html">Pricing</a></li> -->
            </ul>
            <div class="my-auto" id="get-started-div">
                <a href="#signup">
                    <p class="text-center text-black my-auto" id="get-started">Sign Up</p>
                </a>
            </div>
        </div>
    </div>
</nav>